import { Box, Stack, Text } from '@chakra-ui/react';
import { Collapse } from '@time-line/components/common';

import { BlogSectionHeading } from '../BlogSectionHeading';

interface TranscriptProps {
  transcript: {
    speaker: string;
    dialogue: string;
  }[];
}

export function Transcript({ transcript }: TranscriptProps) {
  return (
    <Box position="relative">
      <BlogSectionHeading removeBorder id="transcript">
        Transcript
      </BlogSectionHeading>
      <Collapse collapsedHeight={150}>
        <Stack spacing="xs">
          {transcript.map((discourse, n) => (
            <Stack
              key={n}
              pl="m"
              as="dl"
              spacing="4xs"
              borderLeft="1px"
              borderColor="gray.600"
            >
              <Text size="body-serif" as="dt">
                {discourse.speaker}
              </Text>
              <Text as="dd" size="body-serif">
                {discourse.dialogue}
              </Text>
            </Stack>
          ))}
        </Stack>
      </Collapse>
    </Box>
  );
}
